import { render, staticRenderFns } from "./ILPHome.vue?vue&type=template&id=32db1d7c&scoped=true&"
import script from "./ILPHome.vue?vue&type=script&lang=js&"
export * from "./ILPHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db1d7c",
  null
  
)

export default component.exports